import { render } from "./ModalWarehouse.vue?vue&type=template&id=213fa81e"
import script from "./ModalWarehouse.vue?vue&type=script&lang=js"
export * from "./ModalWarehouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__